'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_Page() {
}
export { $c_Lio_intela_sites_digitalinternship_Page as $c_Lio_intela_sites_digitalinternship_Page };
$p = $c_Lio_intela_sites_digitalinternship_Page.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_Page;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_Page() {
}
export { $h_Lio_intela_sites_digitalinternship_Page as $h_Lio_intela_sites_digitalinternship_Page };
$h_Lio_intela_sites_digitalinternship_Page.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
var $d_Lio_intela_sites_digitalinternship_Page = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i(0, "io.intela.sites.digitalinternship.Page", ({
  av: 1,
  b: 1,
  e: 1,
  a: 1,
  C: 1
}));
export { $d_Lio_intela_sites_digitalinternship_Page as $d_Lio_intela_sites_digitalinternship_Page };
//# sourceMappingURL=io.intela.sites.digitalinternship.-Page.js.map
